import api from '../../../lib/api'

/** Matches the backend POST /compliance/consent response shape. */
export interface ConsentRecord {
  status: string
  leads_updated: number
  consent_for: string
  consent_given_at: string
}

export interface DataAccessExport {
  requested_at: string
  leads: Record<string, unknown>[]
  calls: Record<string, unknown>[]
  whatsapp_messages: Record<string, unknown>[]
  sms_messages: Record<string, unknown>[]
  consent_history: Record<string, unknown>[]
}

export const complianceService = {
  /**
   * Record DPDP consent for all leads matching a mobile number.
   * POST /compliance/consent?mobile=X&consent_for=Y
   */
  async recordConsent(mobile: string, consentFor = 'policy_processing'): Promise<ConsentRecord> {
    const res = await api.post('/compliance/consent', null, {
      params: { mobile, consent_for: consentFor },
    })
    return res.data
  },

  /**
   * Withdraw consent for all leads matching a mobile number.
   * POST /compliance/withdraw-consent?mobile=X
   */
  async withdrawConsent(mobile: string): Promise<{ status: string; leads_updated: number; consent_withdrawn_at: string }> {
    const res = await api.post('/compliance/withdraw-consent', null, {
      params: { mobile },
    })
    return res.data
  },

  /**
   * Submit a data erasure (right-to-be-forgotten) request.
   * POST /compliance/erasure-request?mobile=X
   * Anonymises all PII fields for the given mobile number.
   */
  async requestErasure(mobile: string): Promise<{ status: string; leads_erased: number; erased_at: string; note: string }> {
    const res = await api.post('/compliance/erasure-request', null, {
      params: { mobile },
    })
    return res.data
  },

  /**
   * Export all data held for a mobile number (DPDP data access right).
   * GET /compliance/data-access?mobile=X
   */
  async requestDataAccess(mobile: string): Promise<DataAccessExport> {
    const res = await api.get('/compliance/data-access', {
      params: { mobile },
    })
    return res.data
  },
}
